export default "__VITE_ASSET__6rcErYW9__"